import {inject} from '@angular/core';
import {CanActivateFn, NavigationExtras, Router} from '@angular/router';
import {routes} from '../app.routes';
import {PageTypeService} from '../services/page-type/page-type.service';
import {StepResponseService} from '../services/stepResponse/step-response.service';
import {SessionStorageService} from '../services/session-storage/session-storage.service';
import {FastquoteService} from '../services/fastquote/fastquote.service';
import {RouterDataService} from '../services/router-data/router-data.service';
import {SessionStorageNames} from '../enums/session-storage-names.enum';
import {catchError, firstValueFrom, map, of} from 'rxjs';
import { ReloadPageService } from '../services/reload-page/reload-page.service';
import { LoaderService } from '../services/loader/loader.service';

export const stepGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const sessionStorageService = inject(SessionStorageService);
  const stepResponseService = inject(StepResponseService);
  const fastquoteService = inject(FastquoteService);
  const loaderService = inject(LoaderService);
  const routerDataService = inject(RouterDataService);
  const pageTypeService = inject(PageTypeService);
  const reloadPageService = inject(ReloadPageService);
  const previousUrl = router.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
  const currentUrl = router.getCurrentNavigation()?.finalUrl?.toString();
  let fromGuard!: NavigationExtras;
  const currentStep = route.data['step'];
  const forceRedirectToHome = route?.data?.['forceRedirectToHome'] ?? false;

  const isValidPreviousStep = (currentStep: string, previousUrl: string) => {
    const previousRoute = routes.find((r) => r.path === previousUrl.substring(1));
    const previousStep = previousRoute?.data?.['step'] ?? '-10';

    if (Number(currentStep) > Number(previousStep)) {
      return true;
    }

    return false;
  };

  if(currentUrl) reloadPageService.isUrlReloaded(currentUrl);

  if (forceRedirectToHome && currentUrl === previousUrl) {
    return router.createUrlTree([pageTypeService.getSpecificPageRoute()]);
  }

  if ( reloadPageService.isReloaded
    && !forceRedirectToHome) {
    return loaderService.handleLoadingChain(fastquoteService.getConfiguration()).pipe(
          catchError(() => of(router.createUrlTree([pageTypeService.getSpecificPageRoute()]))),
          map(() => true),
        );
  } else {
    const refreshUrl = sessionStorageService.get('fq-url');

    if (refreshUrl === currentUrl && !forceRedirectToHome) {
      return true;
    }

    if (
      (!stepResponseService.response && !routerDataService.getMotorQuoteObject()) ||
      !previousUrl
      // || !isValidPreviousStep(currentStep, previousUrl)
    ) {
      return router.createUrlTree([pageTypeService.getSpecificPageRoute()], fromGuard);
    }

    return true;
  }
};
